import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX, MailCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState("ask");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const u = params.get("u"), t = params.get("t");

  const go = async (resubscribe) => {
    setBusy(true); setError("");
    try { await api.post("/email/unsubscribe", { u, t, resubscribe }); setState(resubscribe ? "resubscribed" : "done"); }
    catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };

  const Icon = state === "resubscribed" ? MailCheck : MailX;
  return (
    <div className="flex min-h-screen items-center justify-center lf-glow lf-grain p-6" data-testid="unsubscribe-page">
      <div className="relative z-10 w-full max-w-md text-center">
        <Icon className="mx-auto h-10 w-10 text-[#F59E0B]" />
        <h1 className="mt-5 font-display text-4xl text-[#F3EBDD]" data-testid="unsubscribe-title">
          {state === "ask" ? "Unsubscribe from announcements?" : state === "done" ? "You're unsubscribed." : "Welcome back."}
        </h1>
        <p className="mt-2 text-sm text-[#A8A090]">
          {state === "ask" ? "You'll stop getting LoreRight news, promotions and event emails. Account emails like sign-in codes still arrive."
            : state === "done" ? "You won't get announcements anymore. Changed your mind?" : "You'll get LoreRight announcements again."}
        </p>
        {!u || !t ? <p className="mt-6 text-sm text-[#F87171]">This unsubscribe link is incomplete. Use the link from your email.</p> : (
          <div className="mt-8 flex justify-center gap-3">
            {state === "ask" && <Button onClick={() => go(false)} disabled={busy} data-testid="unsubscribe-confirm-button">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Unsubscribe</Button>}
            {state === "done" && <Button variant="outline" onClick={() => go(true)} disabled={busy} data-testid="resubscribe-button">Resubscribe</Button>}
          </div>
        )}
        {error && <p className="mt-4 text-sm text-[#F87171]" data-testid="unsubscribe-error">{error}</p>}
        <Link to="/" className="mt-8 inline-block text-sm text-[#A8A090] hover:text-[#F3EBDD]" data-testid="unsubscribe-home-link">Go to LoreRight</Link>
      </div>
    </div>
  );
}
